import React, { useState } from "react";
import { PageLayout } from "./PageLayout";
import { loginRequest } from "../../../authConfig";
import { callMsGraph } from "./graph";
import { ProfileData } from "./components/ProfileData";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

const ProfileContent = ({requestProfile}) => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  function RequestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) =>
          setGraphData(response)
        );
      });
  }

  return (
    <>
      <h5 className="profileContent">Welcome {accounts[0].name}</h5>
      {graphData ? <ProfileData graphData={graphData} /> : requestProfile ?
          <button variant="secondary" onClick={RequestProfileData}>
          Request Profile
        </button>:""
      }
    </>
  );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = ({requestProfile}) => {
  return (
    <div className="flex flex-col items-center justify-center py-8">
        <AuthenticatedTemplate>
            <ProfileContent requestProfile={requestProfile}/>
        </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <h5 className="card-title">
          Please sign-in to see your profile information.
        </h5>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default function MicrosoftLoginPage() {
  return (
      <div className="flex flex-col items-center justify-center py-8">
    <PageLayout>
      <MainContent requestProfile={true}/>
    </PageLayout>
      </div>
  );
}
export {MainContent}